// @flow

import NestedResource from 'speed-js-core/src/api/NestedResource';

export default class ServiceResellerNestedResource extends NestedResource {
    basePath: string = 'services/services/{parent}/service-reseller/';

    objectPath: string = 'services/services/{parent}/service-reseller/{ident}/';
}
